import { Button, Typography } from "@kyan/ui";
import Image from "next/image";
import Link from "next/link";

import { routes } from "#/config/routes";

export const EmptyState: React.FC = () => {
  return (
    <div className="grid flex-1 place-items-center content-center">
      <Typography
        primary
        className="flex max-w-44 flex-wrap items-center justify-center gap-x-1 text-center"
      >
        Select an option from the{" "}
        <Link href={routes.options()}>
          <Button variant="link">Orderbook</Button>
        </Link>{" "}
        or head to the{" "}
        <Link href={routes.combo}>
          <Button variant="link">Combo page</Button>
        </Link>
      </Typography>
      <Image
        alt="Kyan"
        width={70}
        height={70}
        src="/images/common/kyan-crystal.png"
      />
    </div>
  );
};
